import React from "react"

import Button from "src/newUikit/Button"
import { Indent } from "src/uikit"

import * as S from "./styled"
import Headline from "./components/Headline"
import BgEl1 from "./assets/bg-elem-1.svg"

const Banner = ({ json, image, ctaBtnName, onCtaClick }) => {
  return (
    <S.Container>
      <Indent lg={58} md={80} sm={40} />
      <div className="inner">
        <div className="text-container">
          <Headline json={json} />
          <div className="buttons-container">
            <Button color="cyan" onClick={onCtaClick} full>
              {ctaBtnName}
            </Button>
          </div>
        </div>
        <div className="image-container">
          <img
            className="lazyload"
            data-src={image?.file?.url}
            alt={image?.description}
          />
        </div>

        <BgEl1 className="bg-1" />
      </div>
      <Indent lg={78} md={20} sm={0} />
    </S.Container>
  )
}

export default Banner
